import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useUpdateUserMutation } from "slices/usersApi";
import Swal from "sweetalert2";
import { useGetLocationsQuery } from "slices/common/locationSlice";
import { useLinkLocationMutation } from "slices/beautyApp/beauticianSlice";
import { useAddClinicLocationsMutation } from "slices/wellness/clinicSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

function Location({ open, data, usertype, onClose }) {
  const [update] = useLinkLocationMutation();
  const [clinicUpdate] = useAddClinicLocationsMutation();
  const { data: locations } = useGetLocationsQuery({});

  const [availableAreas, setAvailableAreas] = useState([]);

  useEffect(() => {
    if (locations) {
      // if user already has a saved city in DB, find it
      const cityObj = locations?.data?.data?.find(
        (c) =>
          c._id === data?.areaLinks?.[0]?.city ||
          c.city === data?.areaLinks?.[0]?.city
      );
      setAvailableAreas(cityObj?.areas || []);
    }
  }, [locations, data]);

  console.log("loc", locations);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: data?._id,
      city: "",
      areas: [],
      // city: data?.areaLinks?.[0]?.city || "",
      // areas: data?.areaLinks?.map((c) => c.area?._id) || [],
    },
    validationSchema: Yup.object({
      city: Yup.string().required("City is required"),
      areas: Yup.array().min(1, "At least one area must be selected"),
    }),
    onSubmit: async (values) => {
      try {
        console.log("Updated values:", values);
        if (usertype === "beautician") {
          const response = await update(values).unwrap();
          if (response) {
            onClose();
          }
        } else if (usertype === "clinic") {
          const response = await clinicUpdate(values).unwrap();
          if (response) {
            onClose();
          }
        }
      } catch (error) {
        onClose();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "Server error",
        });
      }
    },
  });

  const { values, setFieldValue, errors, touched } = formik;

  return (
    <Modal open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Add Locations and Areas
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          {/* City Select */}
          <FormControl fullWidth margin="normal">
            <InputLabel id="city-label">City</InputLabel>
            <Select
              labelId="city-label"
              name="city"
              value={values.city}
              onChange={(e) => {
                const cityId = e.target.value;
                setFieldValue("city", cityId);
                setFieldValue("areas", []); // reset areas
                const cityObj = locations?.data?.data?.find(
                  (c) => c._id === cityId
                );
                setAvailableAreas(cityObj?.areas || []);
              }}
            >
              {locations?.data?.data?.map((city) => (
                <MenuItem key={city._id} value={city._id}>
                  {city.cityName}
                </MenuItem>
              ))}
            </Select>
            {touched.city && errors.city && (
              <Typography color="error" variant="caption">
                {errors.city}
              </Typography>
            )}
          </FormControl>

          {/* Areas Multi Select */}
          <FormControl fullWidth margin="normal">
            <InputLabel id="areas-label">Areas</InputLabel>
            <Select
              labelId="areas-label"
              multiple
              name="areas"
              value={values.areas}
              onChange={(e) => setFieldValue("areas", e.target.value)}
              input={<OutlinedInput label="Areas" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((id) => {
                    const area = availableAreas.find((a) => a._id === id);
                    return <Chip key={id} label={area?.areaName || id} />;
                  })}
                </Box>
              )}
            >
              {availableAreas.map((area) => (
                <MenuItem key={area._id} value={area._id}>
                  {area.areaName}
                </MenuItem>
              ))}
            </Select>
            {touched.areas && errors.areas && (
              <Typography color="error" variant="caption">
                {errors.areas}
              </Typography>
            )}
          </FormControl>

          <Box mt={4} display="flex" justifyContent="center" gap={2}>
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              Update
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default Location;
